import { InjectionToken } from '@angular/core';

export interface SideOverlayConfig<D = any> {
  hasBackdrop?: boolean;
  backdropClass?: string;
  data?: D;
}

export const SIDE_OVERLAY_DATA = new InjectionToken<string>('SIDE_OVERLAY_DATA');
